export default __webpack_public_path__ + "static/media/sander-sammy-q7ZlbWbDnYo-unsplash-min.574f01ca.jpg";